import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IClinicToClinicTransferFilterBody,
  IClinicToClinicTransferInventoryPostResponse,
  IClinicToClinicTransferPostBody,
} from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

export const useOrderTransferInventoryListAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<IClinicToClinicTransferPostBody | null>(null);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const clearSearchResults = () => {
    setData(null);
  };

  const execute = useCallback(
    async (filterBody: IClinicToClinicTransferFilterBody, pageSize: string, pageNumber: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .post(
            `${INVENTORY_MODULE?.ORDER_TRANSFER_INVENTORY_LIST?.baseURL}?page_size=${pageSize}&page_number=${pageNumber}`,
            filterBody,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IClinicToClinicTransferInventoryPostResponse>) => {
            if (res.data.status === true) {
              const resultData: IClinicToClinicTransferPostBody = {
                total_items: res.data.data.total_items,
                data: res.data.data.data,
              };
              setData(resultData);
              return { status: true, message: "batch", data: resultData };
            } else {
              setData(null);
              return { status: false, message: "product_not_filtered", data: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "product_not_filtered", data: null };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: "product_not_filtered", data: null };
      }
    },
    [dispatch],
  );
  return { data, execute, clearSearchResults };
};
